import React, {PureComponent} from 'react'
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import { submit } from 'redux-form'

class FormSubmitButton extends PureComponent {

    static propTypes = {
        formName: PropTypes.string.isRequired
    };

    render() {
        const {className, children, dispatch, formName} = this.props;

        return <button
            type="button"
            className={className}
            onClick={() => dispatch(submit(formName))}
        >
            {children}
        </button>;
    }
}

export default connect()(FormSubmitButton)